import GSOParasite from '../../../Game/Base/GSOParasite';
import CanvasBlokButton from '../../CanvasBlokButton';
import Blok from '../../../Game/Level/Blok';
import ClickVoid from '../ClickVoid';
import { Cursor } from '../../Cursor';
import Vector from '../../../Game/Base/Math/Vector';

// The blokmanager for the gamekit is responsible for the list of blokken inside of the level.
export default class BlokManager extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);
        this.blokEditor = realParent;
        this.levelEditor = this.blokEditor.levelEditor;
        this.gameKit = this.levelEditor.gameKit;

        this._blokCollider = new CanvasBlokButton(this);
        this._blokCollider.disable();

        // Click void for deselecting objects
        this.clickVoidButton = new ClickVoid(this);
        this.clickVoidButton.zIndex = -9999;
        this.clickVoidButton.onHoverMove = function(mousePosition) {
            this._gsoParent.updateHoveredBlok();
        };
        this.clickVoidButton.onMouseDown = function(mousePosition) {
            realParent.levelEditor.onMouseDown(mousePosition);
            this.startPosition = mousePosition.copy();
            this.enableDeselect = true;
        };
        this.clickVoidButton.onMouseMove = function(mousePosition) {
            realParent.levelEditor.onMouseMove(mousePosition);
            if (mousePosition.sub(this.startPosition).length() >= 5) {
                this.enableDeselect = false;
            }
        };
        this.clickVoidButton.onMouseUp = function(mousePosition) {
            if (this.enableDeselect) realParent.setSelectedBlok(null);
            realParent.levelEditor.onMouseUp(mousePosition);
        };

        this.clickVoidButton.onHoverEnter = function() {
            realParent.gameKit.setCursor(Cursor.def);
        };
    }

    _getLevel() {
        return this._gsoParent;
    }

    getBlokByUUID(uuid) {
        const level = this._getLevel();
        if (!level) return;
        const blok = level.blokken.findByUUID(uuid);
        if (blok) return null;
        return blok;
    }

    copyBlok(blok, select = true) {
        const newBlok = this.createNewBlok(false);
        const uuid = newBlok.uuid;

        newBlok.deserialize(blok.serialize());
        newBlok.uuid = uuid;

        newBlok.position.addm(new Vector(20, 20));

        if (select) this.blokEditor.setSelectedBlok(newBlok);

        newBlok.requestNewVisuals();

        return newBlok;
    }

    deleteBlok(blok) {
        const level = this._getLevel();
        const i = level.blokken.indexOf(blok);
        if (i < 0) throw new Error('Blok was not found in the level that the BlokManager is attached to.');
        level.blokken.splice(i, 1);
        blok.destroy();
    }

    putBlokAtTop(blok) {
        const level = this._getLevel();
        let i = level.blokken.indexOf(blok);
        if (i < 0) throw new Error('Blok was not found in the level that the BlokManager is attached to.');
        level.blokken.splice(i, 1);
        level.blokken.push(blok);

        // Update GSO child order while we're at it.
        i = level._gsoChildren.indexOf(blok);
        if (i < 0) throw new Error('Blok is not a GSO child of the level that the BlokManager is attached to.');
        level._gsoChildren.splice(i, 1);
        level._gsoChildren.push(blok);

        if (blok._hasVisuals) {
            // Place at top visually as well.
            blok._gsoDestroyVisuals();
            blok._gsoCreateVisuals();
        }
    }

    createNewBlok(select = true) {
        const level = this._getLevel();
        const newBlok = new Blok(level);
        newBlok.position.x = level.view.x;
        newBlok.position.y = level.view.y;
        level.blokken.push(newBlok);
        if (level._hasVisuals) newBlok._gsoCreateVisuals();
        if (select) this.blokEditor.setSelectedBlok(newBlok);
        return newBlok;
    }

    onUpdate(deltaTime) {
        this.updateHoveredBlok();
    }

    updateHoveredBlok() {
        // Check collision with blokken.
        const level = this._getLevel();
        const game = level.getGame();

        let candidate = null;
        for (let i = 0; i < level.blokken.length; i++) {
            const blok = level.blokken[i];
            if (blok) {
                this._blokCollider.blok = blok;
                if (this._blokCollider.checkUICollision(game.mousePosition)) {
                    candidate = blok;
                }
                this._blokCollider.blok = null;
            }
        }
        this._blokCollider.blok = level.player;
        if (this._blokCollider.checkUICollision(game.mousePosition)) {
            candidate = level.player;
        }
        this._blokCollider.blok = null;

        if (candidate) {
            this.gameKit.setCursor(Cursor.pointer);
        }

        this.blokEditor.setHoveredBlok(candidate);
        return candidate;
    }

    onAttach() {}

    onDetach() {}
}
